



























































































































































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import LanguagesStore from "@/mixins/constants/languagesStore";
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { IPWhitelistOptions, IPWhitelistTypes } from "@/data/constants";

// Types
import { IUser } from "@/models/users";

@Component({
  components: {
    "email-history-status": () =>
      import("@/components/app/global/emailHistory/emailHistoryStatus.vue"),
    "phone-number-field": () =>
      import("@/components/app/global/fields/phoneNumberField.vue")
  }
})
export default class UserFields extends Mixins(LanguagesStore, HasValidation) {
  @Prop({ required: true })
  public user!: IUser;

  @Prop({ required: true })
  public value!: any;

  @Prop({ required: true })
  public isProcessing!: any;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: true })
  public controlIpWhitelist!: boolean;

  public sendingVerificationEmail = false;

  public ipWhitelistOptions = IPWhitelistOptions(this);

  public get form() {
    return this.value;
  }

  public set form(value) {
    this.$emit("input", value);
  }

  public manageWhitelistedIps(value) {
    if (value !== IPWhitelistTypes.SECURE) {
      this.form.whitelisted_ips = "";
    }
  }

  public resendVerification() {
    if (!this.canResendVerificationEmail) {
      return;
    }
    this.sendingVerificationEmail = true;
    this.$store
      .dispatch(`data/${DataModules.USERS}/resendVerification`, {
        data: {
          user_id: this.user.id
        }
      })
      .then(() => {
        this.$buefy.toast.open({
          message: this.$t("_.verification_email_sent") as string
        });
      })
      .catch(error => {
        this.$store.dispatch("api/handleValidationError", {
          error,
          vm: this
        });
      })
      .finally(() => (this.sendingVerificationEmail = false));
  }

  public get canResendVerificationEmail() {
    return this.$userCan("resend_user_verification_email");
  }

  public get isApiToken() {
    return this.user.api_user;
  }
}
